"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
/**
 * This barrel file provides the exports for shared resources
 */
__export(require('./ng2-tweet.component'));
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ng2-tweet/lib/components/ng2-tweet/index.js
// module id = ./node_modules/ng2-tweet/lib/components/ng2-tweet/index.js
// module chunks = vendor